<script lang="ts">
  import { navigating, page } from '$app/stores';
  import { onMount } from 'svelte';
  import type { Navigation } from '@sveltejs/kit';
  import { sendAnalyticsEvent } from '$lib/services/analytics';
  import { getPageAttributes } from '$lib/utils/analytics';
  import { EventNames } from '$lib/types/analytics';

  const triggerPageViewAnalytics = (navigation: Navigation) => {
    const { from, to } = navigation;
    const fromPathParams = from?.url?.pathname?.split('/')?.slice(1) || [];
    const toPathParams = to?.url?.pathname?.split('/')?.slice(1) || [];
    const [previous_content_type, previous_page_name] = getPageAttributes(fromPathParams);
    const [content_type, page_name, category_name, article_id] = getPageAttributes(toPathParams);
    sendAnalyticsEvent(EventNames.VIEW_PAGE, {
      content_type,
      previous_content_type,
      previous_page_name,
      page_name,
      category_name,
      article_id
    });
  };

  $: if ($navigating) {
    triggerPageViewAnalytics($navigating);
  }
  onMount(() => {
    if ($page) {
      const pathParams = $page?.url?.pathname?.split('/')?.slice(1) || [];
      const [content_type, page_name] = getPageAttributes(pathParams);
      sendAnalyticsEvent(EventNames.VIEW_PAGE, {
        content_type,
        page_name
      });
    }
  });
</script>
